/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/experiment.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1Experiment } from './V2beta1Experiment';
import {
  V2beta1ExperimentFromJSON,
  V2beta1ExperimentFromJSONTyped,
  V2beta1ExperimentToJSON,
  V2beta1ExperimentToJSONTyped,
} from './V2beta1Experiment';

/**
 *
 * @export
 * @interface V2beta1ListExperimentsResponse
 */
export interface V2beta1ListExperimentsResponse {
  /**
   * A list of experiments returned.
   * @type {Array<V2beta1Experiment>}
   * @memberof V2beta1ListExperimentsResponse
   */
  experiments?: Array<V2beta1Experiment>;
  /**
   * The number of experiments for the given query.
   * @type {number}
   * @memberof V2beta1ListExperimentsResponse
   */
  total_size?: number;
  /**
   * The token to list the next page of experiments.
   * @type {string}
   * @memberof V2beta1ListExperimentsResponse
   */
  next_page_token?: string;
}

/**
 * Check if a given object implements the V2beta1ListExperimentsResponse interface.
 */
export function instanceOfV2beta1ListExperimentsResponse(
  value: object,
): value is V2beta1ListExperimentsResponse {
  return true;
}

export function V2beta1ListExperimentsResponseFromJSON(json: any): V2beta1ListExperimentsResponse {
  return V2beta1ListExperimentsResponseFromJSONTyped(json, false);
}

export function V2beta1ListExperimentsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1ListExperimentsResponse {
  if (json == null) {
    return json;
  }
  return {
    experiments:
      json['experiments'] == null
        ? undefined
        : (json['experiments'] as Array<any>).map(V2beta1ExperimentFromJSON),
    total_size: json['total_size'] == null ? undefined : json['total_size'],
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
  };
}

export function V2beta1ListExperimentsResponseToJSON(json: any): V2beta1ListExperimentsResponse {
  return V2beta1ListExperimentsResponseToJSONTyped(json, false);
}

export function V2beta1ListExperimentsResponseToJSONTyped(
  value?: V2beta1ListExperimentsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experiments:
      value['experiments'] == null
        ? undefined
        : (value['experiments'] as Array<any>).map(V2beta1ExperimentToJSON),
    total_size: value['total_size'],
    next_page_token: value['next_page_token'],
  };
}
